
<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="show"
      persistent
      width="70%"
      height="80%"
    >
      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          Understanding The Terms
        </v-card-title>
  
        <v-card-text class="grey lighten-3">
          <v-container>
            <v-layout column style="height: 60vh; position: relative">
              <v-flex xs12 style="overflow: auto">

                <v-flex xs12 pl-1 pr-2 ml-1 mr-1 pb-3>
                  <div @click="selectedCategory = 'realestate'">
                    <intro-bar
                      name="REAL ESTATE"
                      cost="1"
                      icon="business"
                      :color="selectionColor('realestate','#A2BDE8')"
                      length=0
                    >
                    </intro-bar>
                  </div>
                </v-flex>

                <v-flex xs12 pl-1 pr-2 ml-1 mr-1 pb-3>
                  <div @click="selectedCategory = 'labor'">
                    <intro-bar
                      name="LABOR"
                      cost="2"
                      icon="person"
                      :color="selectionColor('labor', '#4F78C4')"
                      length=0
                    >
                    </intro-bar>
                  </div>
                </v-flex>

                <v-flex xs12 pl-1 pr-2 ml-1 mr-1 pb-3>
                  <div @click="selectedCategory = 'inventory'">
                    <intro-bar
                      name="INVENTORY CARRYING"
                      cost="4"
                      icon="dashboard"
                      :color="selectionColor('inventory', '#3C5990')"
                      length=0
                    >
                    </intro-bar>
                  </div>
                </v-flex>

                <v-flex xs12 pl-1 pr-2 ml-1 mr-1 pb-3>
                  <div @click="selectedCategory = 'transportation'">
                    <intro-bar
                      name="TRANSPORTATION"
                      cost="10"
                      icon="local_shipping"
                      :color="selectionColor('transportation', '#3C385A')"
                      length=0
                    >
                    </intro-bar>
                  </div>
                </v-flex>

                <div class="helpcontent">
                  <v-card style="height: 97%; overflow: scroll" class="ml-1 mr-1 mt-2">
                  <div v-show="selectedCategory == 'realestate'" class="pa-3">
                    <h1>Real Estate</h1>
                    <p>
                      The cost associated with owning or leasing the facility itself. Total cost will be a combination of several factors:
                    </p>
                    <ul>
                      <li>Size of facility</li>
                      <li>Market rates of the location</li>
                      <li>Quality of the building</li>
                      <li>Material Handling Equipment investment inside the facility</li>
                    </ul>
                    <br />
                    <p>
                      Real Estate costs typically account for less than 5% of a network's overall operating costs.
                    </p>
                  </div>
                  <div v-show="selectedCategory == 'labor'" class="pa-3">
                    <h1>Labor</h1>
                    <p>
                      The cost associated with staffing a working facility. Recent changes in state-wide minimum wage and the trend for 
                      e-commerce type facilities employing upwards of 2,000 people have made labor a key factor in location decisions. 
                    </p>
                    <p>
                      Combining labor with transportation and inventory costs, the three typically account for 80% of a network’s 
                      overall operating cost. 
                    </p>

                  </div>
                  <div v-show="selectedCategory == 'inventory'" class="pa-3">
                    <h1>Inventory</h1>
                    <p>
                      The costs associated with holding inventory within the network. Holding cost can be attributed to a number of different factors:
                    </p>
                    <ul>
                      <li>Number of locations – the classic supply chain trade off – more locations closer to the customer will reduce delivery costs, but each location requires inventory to be stocked and held</li>
                      <li>Replenishment frequency – the more frequent deliveries are made, the more inventory needs to be replaced</li>
                      <li>Safety stock – facilities need to hold a certain amount to cover fluctuations in demand and an increased speed to customer</li>
                      <li>Cost of Capital – Opportunity cost of building & holding more inventory</li>
                    </ul>
                  </div>
                  <div v-show="selectedCategory == 'transportation'" class="pa-3">
                    <h1>Transportation</h1>
                    <p>
                      The cost of physically moving goods through the network. These costs typically fall into two categories: 
                      Inbound Transportation (often the freight cost) and Outbound Transportation (often the delivery cost).
                    </p>
                    <p>
                      Inbound transportation typically ships by full truckload in standard shipping containers. Inbound shipments 
                      can travel by boat, truck, airplane or rail prior to reaching the warehouse. Each shipping method has its 
                      own set of unique costs.
                    </p>
                    <p>
                      Outbound transportation can travel along several different modes such as Full Truckload, Less than Truckload, 
                      or Small Parcel. Outbound costs are often more expensive and vary greatly depending on the mode.
                    </p>
                  </div>
                  </v-card>
                </div>

              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>


        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="didSelectOK()"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'help-content',
  data () {
    return {
      selectedCategory: 'realestate'
    }
  },

  props: { 
    show: Boolean
  },

  methods: {
    didSelectOK() {
      this.$emit('did-select-ok')      
    },
    selectionColor(category, activeColor) {
      return category == this.selectedCategory ? activeColor : '#ccc'
    }
  },

  components: {
    'intro-bar': () => import ('@/components/IntroBar'),
  }

}

</script>


<style scoped>
.dialog-title {
  font-weight:bold;
  font-size:11pt;
}
.helpcontent {
  position: absolute;
  top: -8px;
  left: 210px;
  width: calc(100% - 210px);
  height: calc(100% + 8px);
  overflow: scroll;
}

.helpcontent, h1 {
  font-size: 18pt;
}
.helpcontent, p {
  font-size: 15pt;
}

</style>